// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManualCGMOrderPopup-module__font-s-10___Zx0Jd {
  font-size: 10px !important;
}

.ManualCGMOrderPopup-module__font-s-12___aU5ik {
  font-size: 12px !important;
}

.ManualCGMOrderPopup-module__font-s-13___RjfAI {
  font-size: 13px !important;
}

.ManualCGMOrderPopup-module__font-s-14___QvmOX {
  font-size: 14px !important;
}

.ManualCGMOrderPopup-module__font-s-15___LyGXF {
  font-size: 15px !important;
}

.ManualCGMOrderPopup-module__font-s-16___DJMup {
  font-size: 16px !important;
}

.ManualCGMOrderPopup-module__font-s-18___Wak3C {
  font-size: 18px !important;
}

.ManualCGMOrderPopup-module__font-s-20___NDAb7 {
  font-size: 20px !important;
}

.ManualCGMOrderPopup-module__font-s-22___AjIQq {
  font-size: 22px !important;
}

.ManualCGMOrderPopup-module__font-s-28___GPIB3 {
  font-size: 28px !important;
}

.ManualCGMOrderPopup-module__font-w-400___KAH9q {
  font-weight: 400 !important;
}

.ManualCGMOrderPopup-module__font-w-500___ML0fc {
  font-weight: 500 !important;
}

.ManualCGMOrderPopup-module__font-w-600___XYKKY {
  font-weight: 600 !important;
}

.ManualCGMOrderPopup-module__font-w-700___UoJL7 {
  font-weight: 700 !important;
}

.ManualCGMOrderPopup-module__p-5___ZADGG {
  padding: 5px !important;
}

.ManualCGMOrderPopup-module__p-12___VZwSS {
  padding: 12px !important;
}

.ManualCGMOrderPopup-module__p-16___Y6YSX {
  padding: 16px !important;
}

.ManualCGMOrderPopup-module__p-30___QFe5n {
  padding: 30px !important;
}

.ManualCGMOrderPopup-module__p-b-0___BHsJO {
  padding-bottom: 0 !important;
}

.ManualCGMOrderPopup-module__p-b-5___n1Vfl {
  padding-bottom: 5px !important;
}

.ManualCGMOrderPopup-module__p-b-10___hbh6c {
  padding-bottom: 10px !important;
}

.ManualCGMOrderPopup-module__p-b-12___PB8lD {
  padding-bottom: 12px !important;
}

.ManualCGMOrderPopup-module__p-b-16___tSWWb {
  padding-bottom: 16px !important;
}

.ManualCGMOrderPopup-module__p-b-18___Vt5Py {
  padding-bottom: 18px !important;
}

.ManualCGMOrderPopup-module__p-b-20___DhA_q {
  padding-bottom: 20px !important;
}

.ManualCGMOrderPopup-module__p-b-25___obIk2 {
  padding-bottom: 25px !important;
}

.ManualCGMOrderPopup-module__p-b-30___jleuM {
  padding-bottom: 30px !important;
}

.ManualCGMOrderPopup-module__p-b-50___w5mBH {
  padding-bottom: 50px !important;
}

.ManualCGMOrderPopup-module__p-t-0___XHIW4 {
  padding-top: 0 !important;
}

.ManualCGMOrderPopup-module__p-t-12___YpXtZ {
  padding-top: 12px !important;
}

.ManualCGMOrderPopup-module__p-t-16___Glszg {
  padding-top: 16px !important;
}

.ManualCGMOrderPopup-module__p-t-18___sZj_P {
  padding-top: 18px !important;
}

.ManualCGMOrderPopup-module__p-t-20___h5XFD {
  padding-top: 20px !important;
}

.ManualCGMOrderPopup-module__p-t-30___DtevS {
  padding-top: 30px !important;
}

.ManualCGMOrderPopup-module__p-t-40___gkROI {
  padding-top: 40px !important;
}

.ManualCGMOrderPopup-module__p-t-50___WCkE5 {
  padding-top: 50px !important;
}

.ManualCGMOrderPopup-module__p-l-20___GW2yi {
  padding-left: 20px !important;
}

.ManualCGMOrderPopup-module__p-l-30___vILfg {
  padding-left: 30px !important;
}

.ManualCGMOrderPopup-module__p-l-40___Eok4Y {
  padding-left: 40px !important;
}

.ManualCGMOrderPopup-module__p-r-16___Rt8oG {
  padding-right: 16px !important;
}

.ManualCGMOrderPopup-module__p-r-20___M13lt {
  padding-right: 20px !important;
}

.ManualCGMOrderPopup-module__p-r-30___umu5E {
  padding-right: 30px !important;
}

.ManualCGMOrderPopup-module__p-r-50___FjJRQ {
  padding-right: 50px !important;
}

.ManualCGMOrderPopup-module__p-r-60___bJvwE {
  padding-right: 60px !important;
}

.ManualCGMOrderPopup-module__m-b-1___Ex8pp {
  margin-bottom: 1px !important;
}

.ManualCGMOrderPopup-module__m-b-2___vVszL {
  margin-bottom: 2px !important;
}

.ManualCGMOrderPopup-module__m-b-6___R80R8 {
  margin-bottom: 6px !important;
}

.ManualCGMOrderPopup-module__m-b-8___eJqr0 {
  margin-bottom: 8px !important;
}

.ManualCGMOrderPopup-module__m-b-10___Nfjp2 {
  margin-bottom: 10px !important;
}

.ManualCGMOrderPopup-module__m-b-14___N2sy5 {
  margin-bottom: 14px !important;
}

.ManualCGMOrderPopup-module__m-b-16___ocVhB {
  margin-bottom: 16px !important;
}

.ManualCGMOrderPopup-module__m-b-20___URYAh {
  margin-bottom: 20px !important;
}

.ManualCGMOrderPopup-module__m-b-22___gj15A {
  margin-bottom: 22px !important;
}

.ManualCGMOrderPopup-module__m-b-24___Twmed {
  margin-bottom: 24px !important;
}

.ManualCGMOrderPopup-module__m-b-30___g64cK {
  margin-bottom: 30px !important;
}

.ManualCGMOrderPopup-module__m-b-32___UvUYx {
  margin-bottom: 32px !important;
}

.ManualCGMOrderPopup-module__m-b-40___L1g1e {
  margin-bottom: 40px !important;
}

.ManualCGMOrderPopup-module__m-t-2___TPrBQ {
  margin-top: 2px !important;
}

.ManualCGMOrderPopup-module__m-t-3___OQ927 {
  margin-top: 3px !important;
}

.ManualCGMOrderPopup-module__m-t-4___GzUo2 {
  margin-top: 4px !important;
}

.ManualCGMOrderPopup-module__m-t-5___lnp6h {
  margin-top: 5px !important;
}

.ManualCGMOrderPopup-module__m-t-8___O1H2y {
  margin-top: 8px !important;
}

.ManualCGMOrderPopup-module__m-t-10___S0ZSB {
  margin-top: 10px !important;
}

.ManualCGMOrderPopup-module__m-t-15___ONdgF {
  margin-top: 15px !important;
}

.ManualCGMOrderPopup-module__m-t-16___QHSN3 {
  margin-top: 16px !important;
}

.ManualCGMOrderPopup-module__m-t-20___Mag3e {
  margin-top: 20px !important;
}

.ManualCGMOrderPopup-module__m-t-22___h0SuM {
  margin-top: 22px !important;
}

.ManualCGMOrderPopup-module__m-t-30___eMyOC {
  margin-top: 30px !important;
}

.ManualCGMOrderPopup-module__m-t-32___Al_GK {
  margin-top: 32px !important;
}

.ManualCGMOrderPopup-module__m-l-auto___GgSMQ {
  margin-left: auto !important;
}

.ManualCGMOrderPopup-module__m-l-4___Tktio {
  margin-left: 4px !important;
}

.ManualCGMOrderPopup-module__m-l-5___PIhsh {
  margin-left: 5px !important;
}

.ManualCGMOrderPopup-module__m-l-6___CnYCO {
  margin-left: 6px !important;
}

.ManualCGMOrderPopup-module__m-l-8___w4RtB {
  margin-left: 8px !important;
}

.ManualCGMOrderPopup-module__m-l-10___W7NVS {
  margin-left: 10px !important;
}

.ManualCGMOrderPopup-module__m-l-16___koX7P {
  margin-left: 16px !important;
}

.ManualCGMOrderPopup-module__m-l-20___bcfNs {
  margin-left: 20px !important;
}

.ManualCGMOrderPopup-module__m-l-24___iy84W {
  margin-left: 24px !important;
}

.ManualCGMOrderPopup-module__m-l-30___LLX4x {
  margin-left: 30px !important;
}

.ManualCGMOrderPopup-module__m-l-35___sPn4M {
  margin-left: 35px !important;
}

.ManualCGMOrderPopup-module__m-l-40___h81GM {
  margin-left: 40px !important;
}

.ManualCGMOrderPopup-module__m-r-8___qnr0M {
  margin-right: 8px !important;
}

.ManualCGMOrderPopup-module__m-r-10___pilrO {
  margin-right: 10px !important;
}

.ManualCGMOrderPopup-module__m-r-16___OUkI0 {
  margin-right: 16px !important;
}

.ManualCGMOrderPopup-module__m-r-20___bqKYR {
  margin-right: 20px !important;
}

.ManualCGMOrderPopup-module__m-r-24___ttpF8 {
  margin-right: 24px !important;
}

.ManualCGMOrderPopup-module__m-r-30___KnY9X {
  margin-right: 30px !important;
}

.ManualCGMOrderPopup-module__m-r-40___trCPJ {
  margin-right: 40px !important;
}

.ManualCGMOrderPopup-module__border-r-3___hw0qi {
  border-radius: 3px !important;
}

.ManualCGMOrderPopup-module__border-r-4___kgqTq {
  border-radius: 4px !important;
}

.ManualCGMOrderPopup-module__border-r-6___VOwJA {
  border-radius: 6px !important;
}

.ManualCGMOrderPopup-module__border-r-10___PhIFM {
  border-radius: 10px !important;
}

.ManualCGMOrderPopup-module__border-r-12___FY90U {
  border-radius: 12px !important;
}

.ManualCGMOrderPopup-module__border-r-16___kaTl7 {
  border-radius: 16px !important;
}

.ManualCGMOrderPopup-module__border-r-50___pCiMb {
  border-radius: 50% !important;
}

.ManualCGMOrderPopup-module__primary-border___Xncoj {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ManualCGMOrderPopup-module__primary-border-b___Ctv9S {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ManualCGMOrderPopup-module__primary-border-t___pX0S3 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ManualCGMOrderPopup-module__primary-border-l___IC5Xx {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ManualCGMOrderPopup-module__primary-border-r___kSBZ4 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ManualCGMOrderPopup-module__secondary-border___Iw2rR {
  border: 1px solid #637768;
}

.ManualCGMOrderPopup-module__secondary-border-b___j_jEo {
  border-bottom: 1px solid #637768;
}

.ManualCGMOrderPopup-module__secondary-border-t___sv6wn {
  border-top: 1px solid #637768;
}

.ManualCGMOrderPopup-module__secondary-border-l___clHRL {
  border-left: 1px solid #637768;
}

.ManualCGMOrderPopup-module__secondary-border-r___ltbRy {
  border-right: 1px solid #637768;
}

.ManualCGMOrderPopup-module__gap-0___K9uTf {
  gap: 0 !important;
}

.ManualCGMOrderPopup-module__gap-2___nNaiB {
  gap: 2px !important;
}

.ManualCGMOrderPopup-module__gap-4___n_O9i {
  gap: 4px !important;
}

.ManualCGMOrderPopup-module__gap-5___ArHuE {
  gap: 5px !important;
}

.ManualCGMOrderPopup-module__gap-6___E6MNV {
  gap: 6px !important;
}

.ManualCGMOrderPopup-module__gap-8___wtWGl {
  gap: 8px !important;
}

.ManualCGMOrderPopup-module__gap-10___L49ub {
  gap: 10px !important;
}

.ManualCGMOrderPopup-module__gap-12___q774K {
  gap: 12px !important;
}

.ManualCGMOrderPopup-module__gap-14___N5h6G {
  gap: 14px !important;
}

.ManualCGMOrderPopup-module__gap-16___YC63z {
  gap: 16px !important;
}

.ManualCGMOrderPopup-module__gap-18___brEq6 {
  gap: 18px !important;
}

.ManualCGMOrderPopup-module__gap-20___d6SaW {
  gap: 20px !important;
}

.ManualCGMOrderPopup-module__gap-24___fnxQD {
  gap: 24px !important;
}

.ManualCGMOrderPopup-module__gap-26___Y7XyU {
  gap: 26px !important;
}

.ManualCGMOrderPopup-module__gap-30___FZwe6 {
  gap: 30px !important;
}

.ManualCGMOrderPopup-module__gap-32___MHoNf {
  gap: 32px !important;
}

.ManualCGMOrderPopup-module__gap-40___BcqZx {
  gap: 40px !important;
}

.ManualCGMOrderPopup-module__gap-50___rC6S9 {
  gap: 50px !important;
}

.ManualCGMOrderPopup-module__flex-1___n85Cj {
  flex: 1;
}

.ManualCGMOrderPopup-module__flex-none___WVmLb {
  flex: none !important;
}

.ManualCGMOrderPopup-module__flex-column___tPn06 {
  display: flex;
  flex-direction: column !important;
}

.ManualCGMOrderPopup-module__flex-row___PAQ96 {
  display: flex;
  flex-direction: row !important;
}

.ManualCGMOrderPopup-module__vertically-centered___fcUxc {
  display: flex;
  align-items: center !important;
}

.ManualCGMOrderPopup-module__horizontally-centered___sTOrZ {
  display: flex;
  justify-content: center !important;
}

.ManualCGMOrderPopup-module__horizontally-end___w4V3w {
  display: flex;
  justify-content: end !important;
}

.ManualCGMOrderPopup-module__vertically-start___cWjPc {
  display: flex;
  align-items: start !important;
}

.ManualCGMOrderPopup-module__space-between___TT9Z0 {
  display: flex;
  justify-content: space-between !important;
}

.ManualCGMOrderPopup-module__flex-wrap___wz6N9 {
  flex-wrap: wrap !important;
}

.ManualCGMOrderPopup-module__height-100___s_JU2 {
  height: 100%;
}

.ManualCGMOrderPopup-module__width-50___PFNYu {
  width: 50% !important;
}

.ManualCGMOrderPopup-module__width-100___A_sxT {
  width: 100%;
}

.ManualCGMOrderPopup-module__cursor-pointer___TpjoL {
  cursor: pointer;
}

.ManualCGMOrderPopup-module__cursor-not-allowed___r6Fkn {
  cursor: not-allowed !important;
}

.ManualCGMOrderPopup-module__absolute-centered___JDTMW {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ManualCGMOrderPopup-module__absolute___oo1Dm {
  position: absolute;
}

.ManualCGMOrderPopup-module__relative___Cjksi {
  position: relative;
}

.ManualCGMOrderPopup-module__fixed___TIQHr {
  position: fixed;
}

.ManualCGMOrderPopup-module__visible___olzML {
  opacity: 1;
}

.ManualCGMOrderPopup-module__invisible___mH9LB {
  opacity: 0;
}

.ManualCGMOrderPopup-module__col-90___e6qtG {
  width: 90% !important;
}

.ManualCGMOrderPopup-module__col-auto___U0jRw {
  width: auto !important;
}

.ManualCGMOrderPopup-module__medical-tabs___uZvoP {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ManualCGMOrderPopup-module__medical-table-new___atxUT {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ManualCGMOrderPopup-module__medical-table-new___atxUT:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ManualCGMOrderPopup-module__medical-table-new___atxUT::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ManualCGMOrderPopup-module__medical-table-new___atxUT::-webkit-scrollbar-track {
  display: none;
}
.ManualCGMOrderPopup-module__medical-table-new___atxUT.ManualCGMOrderPopup-module__no-pagination___CKetN {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ManualCGMOrderPopup-module__medical-table-new___atxUT.ManualCGMOrderPopup-module__no-pagination___CKetN:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ManualCGMOrderPopup-module__medical-table-new___atxUT.ManualCGMOrderPopup-module__no-pagination___CKetN::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ManualCGMOrderPopup-module__medical-table-new___atxUT.ManualCGMOrderPopup-module__no-pagination___CKetN::-webkit-scrollbar-track {
  display: none;
}

.ManualCGMOrderPopup-module__medical-table-empty___saYJY {
  padding: 14px 40px !important;
}

.ManualCGMOrderPopup-module__icon-btn___oNO85 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ManualCGMOrderPopup-module__search-icon___WtN43 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ManualCGMOrderPopup-module__disable-select____YQno {
  user-select: none;
}

.ManualCGMOrderPopup-module__break-word___yzo8C {
  word-break: break-word;
}

.ManualCGMOrderPopup-module__popup-clear-btn___qKr9m {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ManualCGMOrderPopup-module__scroll-m-b-20___HatYd {
  scroll-margin-bottom: 20px;
}

.ManualCGMOrderPopup-module__grid___n3Nbi {
  display: grid;
  padding: 25px 30px;
  grid-row-gap: 15px;
  align-items: center;
  grid-column-gap: 20px;
  grid-template-columns: repeat(3, 1fr);
}
.ManualCGMOrderPopup-module__grid___n3Nbi .ManualCGMOrderPopup-module__width100____uYMa {
  grid-column: 3 span;
}
.ManualCGMOrderPopup-module__grid___n3Nbi .ManualCGMOrderPopup-module__width66___b71Ex {
  grid-column: 2 span;
}

.ManualCGMOrderPopup-module__buttonsContainer___FWU74 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
  justify-content: end;
  padding: 30px;
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/ManualCGMOrderPopup/ManualCGMOrderPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qCAAA;AA8pBF;AA5pBE;EACE,mBAAA;AA8pBJ;AA3pBE;EACE,mBAAA;AA6pBJ;;AAzpBA;EACE,2CAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AA4pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.grid {\n  display: grid;\n  padding: 25px 30px;\n  grid-row-gap: 15px;\n  align-items: center;\n  grid-column-gap: 20px;\n  grid-template-columns: repeat(3, 1fr);\n\n  .width100 {\n    grid-column: 3 span;\n  }\n\n  .width66 {\n    grid-column: 2 span;\n  }\n}\n\n.buttonsContainer {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n  justify-content: end;\n  padding: 30px;\n  display: flex;\n  gap: 16px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ManualCGMOrderPopup-module__font-s-10___Zx0Jd`,
	"fontS12": `ManualCGMOrderPopup-module__font-s-12___aU5ik`,
	"fontS13": `ManualCGMOrderPopup-module__font-s-13___RjfAI`,
	"fontS14": `ManualCGMOrderPopup-module__font-s-14___QvmOX`,
	"fontS15": `ManualCGMOrderPopup-module__font-s-15___LyGXF`,
	"fontS16": `ManualCGMOrderPopup-module__font-s-16___DJMup`,
	"fontS18": `ManualCGMOrderPopup-module__font-s-18___Wak3C`,
	"fontS20": `ManualCGMOrderPopup-module__font-s-20___NDAb7`,
	"fontS22": `ManualCGMOrderPopup-module__font-s-22___AjIQq`,
	"fontS28": `ManualCGMOrderPopup-module__font-s-28___GPIB3`,
	"fontW400": `ManualCGMOrderPopup-module__font-w-400___KAH9q`,
	"fontW500": `ManualCGMOrderPopup-module__font-w-500___ML0fc`,
	"fontW600": `ManualCGMOrderPopup-module__font-w-600___XYKKY`,
	"fontW700": `ManualCGMOrderPopup-module__font-w-700___UoJL7`,
	"p5": `ManualCGMOrderPopup-module__p-5___ZADGG`,
	"p12": `ManualCGMOrderPopup-module__p-12___VZwSS`,
	"p16": `ManualCGMOrderPopup-module__p-16___Y6YSX`,
	"p30": `ManualCGMOrderPopup-module__p-30___QFe5n`,
	"pB0": `ManualCGMOrderPopup-module__p-b-0___BHsJO`,
	"pB5": `ManualCGMOrderPopup-module__p-b-5___n1Vfl`,
	"pB10": `ManualCGMOrderPopup-module__p-b-10___hbh6c`,
	"pB12": `ManualCGMOrderPopup-module__p-b-12___PB8lD`,
	"pB16": `ManualCGMOrderPopup-module__p-b-16___tSWWb`,
	"pB18": `ManualCGMOrderPopup-module__p-b-18___Vt5Py`,
	"pB20": `ManualCGMOrderPopup-module__p-b-20___DhA_q`,
	"pB25": `ManualCGMOrderPopup-module__p-b-25___obIk2`,
	"pB30": `ManualCGMOrderPopup-module__p-b-30___jleuM`,
	"pB50": `ManualCGMOrderPopup-module__p-b-50___w5mBH`,
	"pT0": `ManualCGMOrderPopup-module__p-t-0___XHIW4`,
	"pT12": `ManualCGMOrderPopup-module__p-t-12___YpXtZ`,
	"pT16": `ManualCGMOrderPopup-module__p-t-16___Glszg`,
	"pT18": `ManualCGMOrderPopup-module__p-t-18___sZj_P`,
	"pT20": `ManualCGMOrderPopup-module__p-t-20___h5XFD`,
	"pT30": `ManualCGMOrderPopup-module__p-t-30___DtevS`,
	"pT40": `ManualCGMOrderPopup-module__p-t-40___gkROI`,
	"pT50": `ManualCGMOrderPopup-module__p-t-50___WCkE5`,
	"pL20": `ManualCGMOrderPopup-module__p-l-20___GW2yi`,
	"pL30": `ManualCGMOrderPopup-module__p-l-30___vILfg`,
	"pL40": `ManualCGMOrderPopup-module__p-l-40___Eok4Y`,
	"pR16": `ManualCGMOrderPopup-module__p-r-16___Rt8oG`,
	"pR20": `ManualCGMOrderPopup-module__p-r-20___M13lt`,
	"pR30": `ManualCGMOrderPopup-module__p-r-30___umu5E`,
	"pR50": `ManualCGMOrderPopup-module__p-r-50___FjJRQ`,
	"pR60": `ManualCGMOrderPopup-module__p-r-60___bJvwE`,
	"mB1": `ManualCGMOrderPopup-module__m-b-1___Ex8pp`,
	"mB2": `ManualCGMOrderPopup-module__m-b-2___vVszL`,
	"mB6": `ManualCGMOrderPopup-module__m-b-6___R80R8`,
	"mB8": `ManualCGMOrderPopup-module__m-b-8___eJqr0`,
	"mB10": `ManualCGMOrderPopup-module__m-b-10___Nfjp2`,
	"mB14": `ManualCGMOrderPopup-module__m-b-14___N2sy5`,
	"mB16": `ManualCGMOrderPopup-module__m-b-16___ocVhB`,
	"mB20": `ManualCGMOrderPopup-module__m-b-20___URYAh`,
	"mB22": `ManualCGMOrderPopup-module__m-b-22___gj15A`,
	"mB24": `ManualCGMOrderPopup-module__m-b-24___Twmed`,
	"mB30": `ManualCGMOrderPopup-module__m-b-30___g64cK`,
	"mB32": `ManualCGMOrderPopup-module__m-b-32___UvUYx`,
	"mB40": `ManualCGMOrderPopup-module__m-b-40___L1g1e`,
	"mT2": `ManualCGMOrderPopup-module__m-t-2___TPrBQ`,
	"mT3": `ManualCGMOrderPopup-module__m-t-3___OQ927`,
	"mT4": `ManualCGMOrderPopup-module__m-t-4___GzUo2`,
	"mT5": `ManualCGMOrderPopup-module__m-t-5___lnp6h`,
	"mT8": `ManualCGMOrderPopup-module__m-t-8___O1H2y`,
	"mT10": `ManualCGMOrderPopup-module__m-t-10___S0ZSB`,
	"mT15": `ManualCGMOrderPopup-module__m-t-15___ONdgF`,
	"mT16": `ManualCGMOrderPopup-module__m-t-16___QHSN3`,
	"mT20": `ManualCGMOrderPopup-module__m-t-20___Mag3e`,
	"mT22": `ManualCGMOrderPopup-module__m-t-22___h0SuM`,
	"mT30": `ManualCGMOrderPopup-module__m-t-30___eMyOC`,
	"mT32": `ManualCGMOrderPopup-module__m-t-32___Al_GK`,
	"mLAuto": `ManualCGMOrderPopup-module__m-l-auto___GgSMQ`,
	"mL4": `ManualCGMOrderPopup-module__m-l-4___Tktio`,
	"mL5": `ManualCGMOrderPopup-module__m-l-5___PIhsh`,
	"mL6": `ManualCGMOrderPopup-module__m-l-6___CnYCO`,
	"mL8": `ManualCGMOrderPopup-module__m-l-8___w4RtB`,
	"mL10": `ManualCGMOrderPopup-module__m-l-10___W7NVS`,
	"mL16": `ManualCGMOrderPopup-module__m-l-16___koX7P`,
	"mL20": `ManualCGMOrderPopup-module__m-l-20___bcfNs`,
	"mL24": `ManualCGMOrderPopup-module__m-l-24___iy84W`,
	"mL30": `ManualCGMOrderPopup-module__m-l-30___LLX4x`,
	"mL35": `ManualCGMOrderPopup-module__m-l-35___sPn4M`,
	"mL40": `ManualCGMOrderPopup-module__m-l-40___h81GM`,
	"mR8": `ManualCGMOrderPopup-module__m-r-8___qnr0M`,
	"mR10": `ManualCGMOrderPopup-module__m-r-10___pilrO`,
	"mR16": `ManualCGMOrderPopup-module__m-r-16___OUkI0`,
	"mR20": `ManualCGMOrderPopup-module__m-r-20___bqKYR`,
	"mR24": `ManualCGMOrderPopup-module__m-r-24___ttpF8`,
	"mR30": `ManualCGMOrderPopup-module__m-r-30___KnY9X`,
	"mR40": `ManualCGMOrderPopup-module__m-r-40___trCPJ`,
	"borderR3": `ManualCGMOrderPopup-module__border-r-3___hw0qi`,
	"borderR4": `ManualCGMOrderPopup-module__border-r-4___kgqTq`,
	"borderR6": `ManualCGMOrderPopup-module__border-r-6___VOwJA`,
	"borderR10": `ManualCGMOrderPopup-module__border-r-10___PhIFM`,
	"borderR12": `ManualCGMOrderPopup-module__border-r-12___FY90U`,
	"borderR16": `ManualCGMOrderPopup-module__border-r-16___kaTl7`,
	"borderR50": `ManualCGMOrderPopup-module__border-r-50___pCiMb`,
	"primaryBorder": `ManualCGMOrderPopup-module__primary-border___Xncoj`,
	"primaryBorderB": `ManualCGMOrderPopup-module__primary-border-b___Ctv9S`,
	"primaryBorderT": `ManualCGMOrderPopup-module__primary-border-t___pX0S3`,
	"primaryBorderL": `ManualCGMOrderPopup-module__primary-border-l___IC5Xx`,
	"primaryBorderR": `ManualCGMOrderPopup-module__primary-border-r___kSBZ4`,
	"secondaryBorder": `ManualCGMOrderPopup-module__secondary-border___Iw2rR`,
	"secondaryBorderB": `ManualCGMOrderPopup-module__secondary-border-b___j_jEo`,
	"secondaryBorderT": `ManualCGMOrderPopup-module__secondary-border-t___sv6wn`,
	"secondaryBorderL": `ManualCGMOrderPopup-module__secondary-border-l___clHRL`,
	"secondaryBorderR": `ManualCGMOrderPopup-module__secondary-border-r___ltbRy`,
	"gap0": `ManualCGMOrderPopup-module__gap-0___K9uTf`,
	"gap2": `ManualCGMOrderPopup-module__gap-2___nNaiB`,
	"gap4": `ManualCGMOrderPopup-module__gap-4___n_O9i`,
	"gap5": `ManualCGMOrderPopup-module__gap-5___ArHuE`,
	"gap6": `ManualCGMOrderPopup-module__gap-6___E6MNV`,
	"gap8": `ManualCGMOrderPopup-module__gap-8___wtWGl`,
	"gap10": `ManualCGMOrderPopup-module__gap-10___L49ub`,
	"gap12": `ManualCGMOrderPopup-module__gap-12___q774K`,
	"gap14": `ManualCGMOrderPopup-module__gap-14___N5h6G`,
	"gap16": `ManualCGMOrderPopup-module__gap-16___YC63z`,
	"gap18": `ManualCGMOrderPopup-module__gap-18___brEq6`,
	"gap20": `ManualCGMOrderPopup-module__gap-20___d6SaW`,
	"gap24": `ManualCGMOrderPopup-module__gap-24___fnxQD`,
	"gap26": `ManualCGMOrderPopup-module__gap-26___Y7XyU`,
	"gap30": `ManualCGMOrderPopup-module__gap-30___FZwe6`,
	"gap32": `ManualCGMOrderPopup-module__gap-32___MHoNf`,
	"gap40": `ManualCGMOrderPopup-module__gap-40___BcqZx`,
	"gap50": `ManualCGMOrderPopup-module__gap-50___rC6S9`,
	"flex1": `ManualCGMOrderPopup-module__flex-1___n85Cj`,
	"flexNone": `ManualCGMOrderPopup-module__flex-none___WVmLb`,
	"flexColumn": `ManualCGMOrderPopup-module__flex-column___tPn06`,
	"flexRow": `ManualCGMOrderPopup-module__flex-row___PAQ96`,
	"verticallyCentered": `ManualCGMOrderPopup-module__vertically-centered___fcUxc`,
	"horizontallyCentered": `ManualCGMOrderPopup-module__horizontally-centered___sTOrZ`,
	"horizontallyEnd": `ManualCGMOrderPopup-module__horizontally-end___w4V3w`,
	"verticallyStart": `ManualCGMOrderPopup-module__vertically-start___cWjPc`,
	"spaceBetween": `ManualCGMOrderPopup-module__space-between___TT9Z0`,
	"flexWrap": `ManualCGMOrderPopup-module__flex-wrap___wz6N9`,
	"height100": `ManualCGMOrderPopup-module__height-100___s_JU2`,
	"width50": `ManualCGMOrderPopup-module__width-50___PFNYu`,
	"width100": `ManualCGMOrderPopup-module__width-100___A_sxT`,
	"cursorPointer": `ManualCGMOrderPopup-module__cursor-pointer___TpjoL`,
	"cursorNotAllowed": `ManualCGMOrderPopup-module__cursor-not-allowed___r6Fkn`,
	"absoluteCentered": `ManualCGMOrderPopup-module__absolute-centered___JDTMW`,
	"absolute": `ManualCGMOrderPopup-module__absolute___oo1Dm`,
	"relative": `ManualCGMOrderPopup-module__relative___Cjksi`,
	"fixed": `ManualCGMOrderPopup-module__fixed___TIQHr`,
	"visible": `ManualCGMOrderPopup-module__visible___olzML`,
	"invisible": `ManualCGMOrderPopup-module__invisible___mH9LB`,
	"col90": `ManualCGMOrderPopup-module__col-90___e6qtG`,
	"colAuto": `ManualCGMOrderPopup-module__col-auto___U0jRw`,
	"medicalTabs": `ManualCGMOrderPopup-module__medical-tabs___uZvoP`,
	"medicalTableNew": `ManualCGMOrderPopup-module__medical-table-new___atxUT`,
	"noPagination": `ManualCGMOrderPopup-module__no-pagination___CKetN`,
	"medicalTableEmpty": `ManualCGMOrderPopup-module__medical-table-empty___saYJY`,
	"iconBtn": `ManualCGMOrderPopup-module__icon-btn___oNO85`,
	"searchIcon": `ManualCGMOrderPopup-module__search-icon___WtN43`,
	"disableSelect": `ManualCGMOrderPopup-module__disable-select____YQno`,
	"breakWord": `ManualCGMOrderPopup-module__break-word___yzo8C`,
	"popupClearBtn": `ManualCGMOrderPopup-module__popup-clear-btn___qKr9m`,
	"scrollMB20": `ManualCGMOrderPopup-module__scroll-m-b-20___HatYd`,
	"grid": `ManualCGMOrderPopup-module__grid___n3Nbi`,
	"width100": `ManualCGMOrderPopup-module__width100____uYMa`,
	"width66": `ManualCGMOrderPopup-module__width66___b71Ex`,
	"buttonsContainer": `ManualCGMOrderPopup-module__buttonsContainer___FWU74`
};
module.exports = ___CSS_LOADER_EXPORT___;
